import { render, staticRenderFns } from "./RecommendedBands.vue?vue&type=template&id=a4be9744"
import script from "./RecommendedBands.vue?vue&type=script&lang=js"
export * from "./RecommendedBands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports